import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export const ReprintSlice = createSlice({
  name: "ReprintSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    Reprint: (state, _: PayloadAction<{request_id: number | string}>) => {
      state.isLoading = true;
    },
    successReprint: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureReprint: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearReprint: (state) => {
      state.data = {};
    },
  },
});

export const {
  Reprint,
  successReprint,
  failureReprint,
  clearReprint,
} = ReprintSlice.actions;

export default ReprintSlice.reducer;
